import React, { createContext, useContext, useState } from 'react';

interface ProductRefreshContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const ProductRefreshContext = createContext<ProductRefreshContextType | undefined>(undefined);

export const useProductRefresh = () => {
  const context = useContext(ProductRefreshContext);
  if (!context) {
    throw new Error('useProductRefresh must be used within ProductRefreshProvider');
  }
  return context;
};

export const ProductRefreshProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <ProductRefreshContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </ProductRefreshContext.Provider>
  );
};
